(function (global) {
  'use strict';

  global.NewHomeSource = global.NewHomeSource || {};
  global.NewHomeSource.Carousel = global.NewHomeSource.Carousel || {};

  const Carousel = global.NewHomeSource.Carousel;

  if (!Carousel.Vector1D ||
    !Carousel.Translate) {
    return;
  }

  class LoopPoint {
    /**
     * Initializes a new instance of the class.
     *
     * @constructor
     * @property {any} loopPoint - The current loop point of the carousel.
     * @property {any} slideLocation - The current slide location.
     * @property {any} translate - The current translate value.
     */
    constructor() {
      this.loopPoint = null;
      this.slideLocation = null;
      this.translate = null;
      this.initial = 0;
      this.altered = 0;
    }

    /**
     * Initializes the loop point for the carousel.
     *
     * @param {Object} state - The current state object, expected to have
     * `get` methods for 'axis', 'slides', and 'contentSize'.
     * @param {Object} options - Configuration options for initialization.
     * @param {number} options.index - The index of the current slide.
     * @param {boolean} options.isEndEdge - Indicates if the carousel is at the end edge.
     * @param {number} options.loopPoint - The loop point value for the carousel.
     */
    initialize(state, options) {
      this.state = state;
      const slides = state.get('slides');
      const contentSize = state.get('contentSize');
      this.setSlideLocation(-1)
        .setLoopPoint(options.loopPoint)
        .setIndex(options.index)
        .setTranslate(state, slides[options.index])
        .setInitial(options.isEndEdge ? 0 : -contentSize)
        .setAltered(options.isEndEdge ? contentSize : 0);
    }

    /**
     * Sets the location of the slide by initializing a new Carousel.Vector1D instance with the given value.
     *
     * @param {number} value - The value to initialize the slide location.
     */
    setSlideLocation(value) {
      this.slideLocation = new Carousel.Vector1D();
      this.slideLocation.initialize(value);
      return this;
    }

    /**
     * Sets the loop point value for the carousel.
     *
     * @param {*} value - The value to set as the loop point.
     * @returns {this} Returns the current instance for method chaining.
     */
    setLoopPoint(value) {
      this.loopPoint = value;
      return this;
    }

    /**
     * Sets the translation state for the carousel.
     *
     * @param {Object} state - The current state of the carousel.
     * @param {number} slide - The index or position of the slide to translate to.
     * @returns {this} Returns the current instance for chaining.
     */
    setTranslate(state, slide) {
      this.translate = new Carousel.Translate();
      this.translate.initialize(state, slide);
      return this;
    }

    /**
     * Sets the initial value for the carousel and returns the current instance for chaining.
     * @param {number} value - The value to set as initial.
     * @returns {this} The current instance for method chaining.
     */
    setInitial(value) {
      this.initial = value;
      return this;
    }

    /**
     * Sets the altered state of the object.
     * @param {boolean} value - The new value for the altered state.
     * @returns {this} Returns the current instance for chaining.
     */
    setAltered(value) {
      this.altered = value;
      return this;
    }

    /**
     * Sets the current index of the carousel.
     * @param {number} index - The index to set.
     * @returns {this} Returns the current instance for chaining.
     */
    setIndex(index) {
      this.index = index;
      return this;
    }

    /**
     * Returns the current loop point value.
     * @returns {*} The value of the loop point.
     */
    getLoopPoint() {
      return this.loopPoint;
    }

    /**
     * Returns the current slide location.
     * @returns {*} The value of the current slide location.
     */
    getSlideLocation() {
      return this.slideLocation;
    }

    /**
     * Returns the current translation value of the carousel.
     * @returns {number} The current translate value.
     */
    getTranslate() {
      return this.translate;
    }

    /**
     * Returns the current index of the carousel.
     * @returns {number} The current index.
     */
    getIndex() {
      return this.index;
    }

    /**
     * Determines which value to return based on the current location and loop point.
     *
     * @returns {*} Returns `this.initial` if the current location is greater than
     * the loop point, otherwise returns `this.altered`.
     */
    target() {
      const location = this.state.get('location');
      return location.get() > this.loopPoint ? this.initial : this.altered;
    }
  }

  global.NewHomeSource.Carousel.LoopPoint = LoopPoint;
}(window));
